import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import authReducer from './slices/authSlice'
import errorReducer from './slices/errorSlice'
import themeReducer from './slices/themeSlice'
import campaignReducer from './slices/campaignSlice'
import influencerReducer from './slices/influencerSlice'
import layoutReducer, { setIntendedPath } from './slices/layoutSlice'
import CampaignDetailsReducer from './slices/campaignDetailsSlice';
import CollaborationReducer from './slices/collaborationSlice';
import CollaborationDetailsReducer from './slices/collaborationDetailsSlice';
import WalletReducer from './slices/walletSlice';
import ReferralsReducer from './slices/referralSlice';
import MembershipReducer from './slices/membershipSlice';
import PricingReducer from './slices/pricingSlice';
import InfluencerInsightsReducer from './slices/influencerInsightsSlice'
import InfluencerContentReducer from './slices/influencerContentSlice';
import PostsReducer from './slices/postsSlice';
import dmAutomationsListSlice from './slices/dmAutomationsListSlice';
import dmAutomationReducer from './slices/dmAutomationSlice';
import permalinkFilesReducer from "./slices/permalinkFilesSlice";
import collaborationMilestonesReducer from "./slices/collaborationMilestoneSlice";
import addressBookReducer from './slices/addressSlice'
import conversionCamaignsReducer from './slices/conversionCampaignSlice';
import { collaborationTasksReducer } from './slices/CollaborationsTasksSlice';
import capacitorStorage from 'redux-persist-capacitor-storage';
import chatReducer from './slices/chatSlice';


const persistedAuthReducer = persistReducer({
    key: 'auth',
    storage: capacitorStorage,
    whitelist: ['user', 'isAuthenticated', 'master', 'firebaseToken'],
    // transforms: [encryptTransform] // To apply Encryption
}, authReducer);

const persistedInfluencerReducer = persistReducer({
    key: 'influencer',
    storage,
    blacklist: ['insights', 'isConnected', 'error', 'loading', 'selectedSocialAccount', 'ticker'],
    // transforms: [encryptTransform] // To apply Encryption
}, influencerReducer);


const persistedThemeReducer = persistReducer({
    key: 'theme',
    storage
}, themeReducer);

export const store = configureStore({
    reducer: {
        auth: persistedAuthReducer,
        error: errorReducer,
        theme: persistedThemeReducer,
        campaigns: campaignReducer,
        influencer: persistedInfluencerReducer,
        layout: layoutReducer,
        campaignDetails: CampaignDetailsReducer,
        collaborations: CollaborationReducer,
        collaborationDetails: CollaborationDetailsReducer,
        wallet: WalletReducer,
        referrals: ReferralsReducer,
        membership: MembershipReducer,
        pricing: PricingReducer,
        influencerInsights: InfluencerInsightsReducer,
        influencerContent: InfluencerContentReducer,
        posts: PostsReducer,
        dmAutomationsList: dmAutomationsListSlice,
        dmAutomations: dmAutomationReducer,
        permalinkFiles: permalinkFilesReducer,
        collaborationMilestones: collaborationMilestonesReducer,
        addressBook: addressBookReducer,
        conversionCampaigns: conversionCamaignsReducer,
        collaborationTasks: collaborationTasksReducer,
        chat: chatReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false, // Required for redux-persist
        }),
});

export const persistor = persistStore(store);

export const getIntendedPath = () => {
    const intended_path = store.getState().layout.intended_path;
    store.dispatch(setIntendedPath('/'));
    return intended_path;
}

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

